module.exports = __webpack_public_path__ + "static/img/img14.9736828.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img14.jpg
// module id = Vnwz
// module chunks = 1